module.exports = __webpack_public_path__ + "static/media/07-05.5d6b2556.png";